import type { FC } from 'react';
import { memo } from 'react';

import ModalBody from '@trend-dev/trendtech-ui/components/UI/Modal/ModalBody';
import ModalFooter from '@trend-dev/trendtech-ui/components/UI/Modal/ModalFooter';

import { text } from './const';
import Controls from './Controls';
import Dialog from './Dialog';
import Header from './Header';
import styles from './styles.module.scss';

const TimerPopup: FC = () => {
    return (
        <Dialog>
            <Header />
            <ModalBody>{text}</ModalBody>
            <ModalFooter className={styles.footer}>
                <Controls />
            </ModalFooter>
        </Dialog>
    );
};

export default memo(TimerPopup);
